"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assert = void 0;
class AssertError extends Error {
}
function assert(condition, message) {
    if (!condition) {
        throw new AssertError(message);
    }
}
exports.assert = assert;
